export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/viral_videos.126c3ba.svg";